<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-8 ml-auto mr-auto">
          <div class="card p-4 shadow-sm" style="border-radius: 15px;">
            <div class="header text-center">
              <h2 class="title font-weight-bolder text-dark" style="font-size: 1.8rem; letter-spacing: -0.5px;">
                Asociación con el RNE
              </h2>
              <p class="category text-muted mt-2" style="font-size: 1rem;">
                Registro Nacional de Entrenadores
              </p>
              
              <!-- RNE Status Badge -->
              <div v-if="!isLoading" class="mt-2 d-flex justify-content-center">
                <span
                  v-if="userIsRne === 1"
                  class="badge bg-success text-white"
                  style="font-size: 0.75rem; border-radius: 10px; padding: 6px 12px;"
                >
                  Usuario asociado a RNE
                </span>
                <span
                  v-else
                  class="badge bg-warning text-white"
                  style="font-size: 0.75rem; border-radius: 10px; padding: 6px 12px; background-color: #fb6340 !important;"
                >
                  Usuario sin asociar a RNE
                </span>
              </div>

              <hr class="my-4" />
            </div>
            
            <div class="content py-2">
              <!-- Explanation for the user -->
              <div class="mb-4 text-start px-3">
                <p class="text-dark" style="font-size: 1.05rem; line-height: 1.6;">
                  El <b>Campus CCD</b> (Centro de Capacitación y Desarrollo) te permite conectar tu cuenta con el <b>RNE</b> (Registro Nacional de Entrenadores).
                </p>
                <p class="text-dark" style="font-size: 1.05rem; line-height: 1.6;">
                  <b>¿Para qué sirve?</b><br />
                  🟢 Permite que el sistema reconozca tu <b>licencia de entrenador</b> automáticamente.<br />
                  📚 Podrás inscribirte y participar en los cursos del CCD que requieren obligatoriamente tener una licencia activa.
                </p>
              </div>

              <!-- Loader -->
              <div v-if="isLoading" class="py-4 text-center">
                <p class="lead text-muted">Comprobando tu estado en RNE...</p>
              </div>

              <!-- Status Alert Messages -->
              <div v-else class="px-3">
                <!-- Info of variables checked -->
                <div class="bg-light p-3 mb-4 text-start" style="border-radius: 10px; font-size: 0.9rem; border: 1px solid #eee;">
                  <span class="text-secondary font-weight-bold d-block mb-1">Datos consultados de tu perfil:</span>
                  📧 Correo: <b>{{ checkedEmail }}</b><br />
                  🪪 Cédula: <b>{{ checkedDni }}</b>
                </div>

                <!-- 2 Cards separadas -->
                <div class="row">
                  <!-- CARD 1: CORREO -->
                  <div class="col-md-6 mb-3">
                    <div class="card p-3 h-100 text-start" style="border-radius: 12px; border: 1px solid #e5e5e5; background-color: #ffffff; box-shadow: none;">
                      <h5 class="font-weight-bold mb-2" style="color: #541A32; font-size: 1.05rem;">
                        <span class="me-2">📧</span> Búsqueda por correo
                      </h5>
                      <hr class="my-2" style="border-color: #f1f1f1;" />
                      
                      <div v-if="matchEmail">
                        <p class="font-weight-bold mb-1" style="font-size: 0.9rem; color: #B49B57;">
                          ✓ Registrado en RNE
                        </p>
                        <p class="text-muted mb-0" style="font-size: 0.85rem; line-height: 1.4;">
                          Se detectó un entrenador registrado con el correo <b>{{ checkedEmail }}</b>.
                          <span v-if="userIsRne === 1" class="d-block mt-2 font-weight-bold text-dark">
                            ✓ Tu cuenta de Campus CCD se encuentra vinculada correctamente.
                          </span>
                          <span v-else class="d-block mt-2 font-weight-bold" style="color: #c09853;">
                            ⚠ Cuenta sin vincular: Tu cuenta de Campus CCD aún no se encuentra vinculada a esta licencia.
                          </span>
                        </p>
                      </div>
                      
                      <div v-else>
                        <p class="text-secondary font-weight-bold mb-1" style="font-size: 0.9rem;">
                          ✗ No registrado
                        </p>
                        <p class="text-muted mb-0" style="font-size: 0.85rem; line-height: 1.4;">
                          No se encontró ninguna cuenta en RNE asociada a <b>{{ checkedEmail }}</b>.
                        </p>
                      </div>
                    </div>
                  </div>

                  <!-- CARD 2: CÉDULA -->
                  <div class="col-md-6 mb-3">
                    <div class="card p-3 h-100 text-start" style="border-radius: 12px; border: 1px solid #e5e5e5; background-color: #ffffff; box-shadow: none;">
                      <h5 class="font-weight-bold mb-2" style="color: #541A32; font-size: 1.05rem;">
                        <span class="me-2">🪪</span> Búsqueda por cédula
                      </h5>
                      <hr class="my-2" style="border-color: #f1f1f1;" />
                      
                      <div v-if="matchDni">
                        <p class="font-weight-bold mb-1" style="font-size: 0.9rem; color: #B49B57;">
                          ✓ Registrada en RNE
                        </p>
                        <p class="text-muted mb-0" style="font-size: 0.85rem; line-height: 1.4;">
                          Se detectó un entrenador con la cédula <b>{{ checkedDni }}</b>.
                          <span v-if="rneUserDni && rneUserDni.email && rneUserDni.email.toLowerCase() !== checkedEmail.toLowerCase()" class="d-block mt-2 font-weight-bold" style="color: #c09853;">
                            ⚠ Correo diferente: En RNE está registrada con el correo <b>{{ rneUserDni.email }}</b> en lugar de tu correo actual.
                          </span>
                        </p>
                      </div>
                      
                      <div v-else>
                        <p class="text-secondary font-weight-bold mb-1" style="font-size: 0.9rem;">
                          ✗ No registrada
                        </p>
                        <p class="text-muted mb-0" style="font-size: 0.85rem; line-height: 1.4;">
                          No se encontró ningún entrenador en RNE asociado a la cédula <b>{{ checkedDni }}</b>.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Nota adicional sobre vinculación -->
                <div v-if="userIsRne === 0" class="mt-3 p-3 text-start" style="border-radius: 10px; background-color: #f8d7da; border: 1px solid #f5c2c7; color: #842029; font-size: 0.9rem;">
                  <strong>Aviso de vinculación:</strong> Aunque existan coincidencias en la búsqueda, tu cuenta de Campus CCD no se encuentra vinculada. Para postularte a cursos con requisitos de licencia, debes completar la asociación. Asegúrate de que tu perfil tenga la misma cédula de identidad que usaste en RNE para poder vincularla.
                </div>
                
                <div class="text-center mt-4 pt-2">
                  <button
                    v-if="userIsRne === 0"
                    type="button"
                    class="btn px-5 py-2.5 font-weight-bold me-2"
                    :style="btnStyle"
                    @click="vincularConRne"
                  >
                    Vincular con RNE
                  </button>
                  <a 
                    href="https://entrenadores.federacionvenezolanafutbol.com/iniciar_sesion" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    class="btn bg-gradient-fvf px-5 py-2.5 font-weight-bold"
                    style="border-radius: 30px; font-size: 1rem; text-transform: none;"
                  >
                    Ir al portal RNE
                  </a>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Swal from 'sweetalert2'

export default {
  name: 'RneView',
  data() {
    return {
      isLoading: true,
      checkedEmail: '',
      checkedDni: '',
      matchEmail: false,
      matchDni: false,
      rneUserEmail: null,
      rneUserDni: null,
      userIsRne: 0
    }
  },
  computed: {
    btnStyle() {
      const isEnabled = this.matchEmail && this.matchDni
      return {
        borderRadius: '30px',
        fontSize: '1rem',
        textTransform: 'none',
        background: isEnabled ? '#B49B57 !important' : '#9F9F9F !important',
        color: 'white !important',
        border: 'none',
        cursor: 'pointer'
      }
    }
  },
  mounted() {
    this.checkRneStatus()
  },
  methods: {
    ...mapActions(['getData', 'updateDataAutenticated', 'createData']),
    checkRneStatus() {
      this.isLoading = true

      // Load CCD profile details to read is_rne directly from DB
      let profileForm = {
        url: 'user/user/myprofile'
      }
      this.getData(profileForm)
        .then((response) => {
          if (response.code === 200 && response.data) {
            this.userIsRne = response.data.is_rne
          }
        })
        .catch((err) => console.error('Error loading CCD profile:', err))

      // Check RNE status matching
      let form = {
        url: 'rne/check_status'
      }
      this.getData(form)
        .then((response) => {
          this.isLoading = false
          if (response.code === 200 && response.data) {
            this.checkedEmail = response.data.checked_email
            this.checkedDni = response.data.checked_dni
            this.matchEmail = response.data.match_email
            this.matchDni = response.data.match_dni
            this.rneUserEmail = response.data.rne_user_email
            this.rneUserDni = response.data.rne_user_dni
          }
        })
        .catch((error) => {
          this.isLoading = false
          console.error('Error checking RNE status:', error)
        })
    },

    vincularConRne() {
      if (!this.matchEmail || !this.matchDni) {
        Swal.fire({
          title: "Atención",
          text: "Tu cedula registrada no se encuentra en RNE Registro Nacional de Entrenadores, por lo tanto no puedes vincular tu cuenta. Asegúrate de que tu perfil tenga la misma cédula de identidad que usaste en RNE para poder vincularla.",
          icon: "warning",
          confirmButtonColor: "#541A32"
        });
        return;
      }

      Swal.fire({
        title: "Vincular cuenta",
        text: "¿Estás seguro de vincular tu cuenta de Campus CCD con el Registro Nacional de Entrenadores (RNE)?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#541A32",
        cancelButtonColor: "#9F9F9F",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sí, vincular"
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          
          let form = {
            url: "rne/associate",
            data: {
              email: this.checkedEmail,
              dni: this.checkedDni
            }
          };

          this.createData(form)
            .then((response) => {
              this.isLoading = false;
              if (response.code === 200) {
                Swal.fire({
                  title: "¡Cuenta vinculada!",
                  text: "Tu cuenta ha sido asociada correctamente al RNE.",
                  icon: "success",
                  confirmButtonColor: "#541A32"
                }).then(() => {
                  window.location.reload();
                });
              } else {
                Swal.fire({
                  title: "Error",
                  text: response.message || "Ocurrió un error al vincular tu cuenta.",
                  icon: "error",
                  confirmButtonColor: "#541A32"
                });
              }
            })
            .catch((err) => {
              this.isLoading = false;
              console.error(err);
              Swal.fire({
                title: "Error",
                text: err.message || "Ocurrió un error, intente más tarde",
                icon: "error",
                confirmButtonColor: "#541A32"
              });
            });
        }
      });
    }
  }
}
</script>

<style scoped>
.bg-gradient-fvf {
  background: #541A32 !important;
  color: white !important;
  border: none;
}
.bg-gradient-fvf:hover {
  background: #6c2342 !important;
  transform: translateY(-1px);
}
</style>
